import dayjs from "dayjs";

export const formatAmount = (amount: string | number | null): string => {
    if (!amount) return '0.00';

    if (typeof amount === 'number') {
        amount = amount.toString();
    }

    amount = amount.replace(',', '.');

    let num = parseFloat(amount);
    if (isNaN(num)) return '0.00';

    // Round to two decimal places
    amount = num.toFixed(2);

    const parts = amount.split('.');
    const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); // Форматирование разделителей тысяч
    const decimalPart = parts[1] ? parts[1].padEnd(2, '0') : '00'; // Всегда два знака после точки

    return `${integerPart}.${decimalPart}`;
};

export function formatDateAndTime(dateString: string | null) {
    if (dateString === null) return '';

    // Добавляем ведущие нули к дню и месяцу, минутам и секундам если они отсутствуют
    const [day, month, year, hour, minute] = dateString.split(/[\/\s:]+/);
    const formattedDateString = `
    ${parseInt(month).toString().padStart(2, '0')}/
    ${parseInt(day).toString().padStart(2, '0')}/
    ${year} ${parseInt(hour).toString().padStart(2, '0')}:
    ${parseInt(minute).toString().padStart(2, '0')}
    `;

    return dayjs(formattedDateString).format('YYYY-MM-DD HH:MM');
}